import { useEffect, useState } from "react";
import { ContentTextArea } from "../../../components/atoms/formFields/textArea";
import { RemarkHistory } from "../../../components/atoms/remarkHistory";
import { useDispatch, useSelector } from "react-redux";
import {
  OrderRemarksHistoryThunk,
  SaveOrderRemarksThunk,
} from "../../../store/thunks/orderThunk";
import { message } from "antd";
import { resetSaveOrderRemark } from "../../../store/slices/orderSlice";

export const OrderRemarks = ({ orderRefId }) => {
  const dispatch = useDispatch();
  const { data: orderRemarks } = useSelector(
    (state) => state.orderRemarkHistory
  );

  const { data: saveRemark, error } = useSelector(
    (state) => state.saveOrderRemark
  );

  const [formState, setFormState] = useState({
    remarks: "",
  });

  useEffect(() => {
    dispatch(
      OrderRemarksHistoryThunk({
        orderRefId: orderRefId,
        paginationFilter: {
          limit: 10,
          offset: 0,
          order: "DESC",
        },
      })
    );
  }, []);
  useEffect(() => {
    if (saveRemark && !error) {
      setFormState({ remarks: "" }); // reset remarks
      // refresh remarks list
      dispatch(
        OrderRemarksHistoryThunk({
          orderRefId: orderRefId,
          paginationFilter: {
            limit: 10,
            offset: 0,
            order: "DESC",
          },
        })
      );
      dispatch(resetSaveOrderRemark());
    }
  }, [orderRefId, saveRemark]);

  useEffect(() => {
    if (saveRemark) {
      dispatch(resetSaveOrderRemark());
    }
  }, [saveRemark]);
  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <div className="Remarks">
            <ContentTextArea
              name={"Remarks"}
              value={formState?.remarks}
              rows={"3"}
              onChange={(e) => {
                setFormState({
                  ...formState,
                  remarks: e.target.value,
                });
              }}
            />
          </div>
        </div>
      </div>
      <div className="row sm-12">
        <div className="col-sm-10 mt-5">
          <RemarkHistory dataRemarks={{ remarks: orderRemarks?.list }} />
        </div>
        <div className="col-sm-2">
          <div className="mt-5 text-right">
            <div>
              <button
                type="submit"
                className="all_bottom_buttons bg-primary"
                onClick={(e) => {
                  e.preventDefault();
                  const trimmedRemarks = formState?.remarks?.trim();

                  if (!trimmedRemarks) {
                    message.error("Remarks cannot be empty.");
                    return;
                  }
                  dispatch(
                    SaveOrderRemarksThunk({
                      id: orderRefId,
                      remarks: formState?.remarks,
                    })
                  );
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
